// src/App.js

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { auth } from './firebaseConfig';
import { onAuthStateChanged, signOut } from 'firebase/auth';

import LoginPage from './components/LoginPage';
import CloudTTSPage from './components/CloudTTSPage';
import GeminiTTSPage from './components/GeminiTTSPage';
import FileManagerPage from './components/FileManagerPage';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe(); // Cleanup subscription
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-xl font-semibold text-gray-700">Loading...</div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-100 flex flex-col">
        {user && (
          <nav className="bg-gradient-to-r from-blue-600 to-purple-700 p-4 shadow-lg">
            <div className="container mx-auto flex justify-between items-center">
              <div className="flex space-x-6">
                <Link to="/cloud-tts" className="text-white text-lg font-medium hover:text-blue-200 transition duration-300">
                  GCP Cloud TTS
                </Link>
                <Link to="/gemini-tts" className="text-white text-lg font-medium hover:text-blue-200 transition duration-300">
                  Gemini TTS
                </Link>
                <Link to="/files" className="text-white text-lg font-medium hover:text-blue-200 transition duration-300">
                  My Files
                </Link>
              </div>
              <div className="flex items-center space-x-4">
                <span className="text-white text-md">Logged in as: {user.email}</span>
                <button
                  onClick={handleLogout}
                  className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg shadow-md transition duration-300"
                >
                  Logout
                </button>
              </div>
            </div>
          </nav>
        )}

        <main className="flex-grow container mx-auto p-6">
          <Routes>
            <Route path="/login" element={user ? <Navigate to="/cloud-tts" /> : <LoginPage />} />
            <Route path="/cloud-tts" element={user ? <CloudTTSPage userId={user.uid} /> : <Navigate to="/login" />} />
            <Route path="/gemini-tts" element={user ? <GeminiTTSPage userId={user.uid} /> : <Navigate to="/login" />} />
            <Route path="/files" element={user ? <FileManagerPage userId={user.uid} /> : <Navigate to="/login" />} />
            <Route path="/" element={user ? <Navigate to="/cloud-tts" /> : <Navigate to="/login" />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;